import { QueryClient } from '@tanstack/react-query';
export const ACTIVE_CLASSNAME = 'border-t-primary-30';
export const queryClient = new QueryClient();
